import { createSelector } from 'reselect'
import { RootState } from '@/store/Reducer'

const selectDashboardV2 = (state: RootState) => state.dashboardV2

export const selectContracts = createSelector(selectDashboardV2, d => d.contracts)
export const selectFilters = createSelector(selectDashboardV2, d => d.filters)
export const selectPagination = createSelector(selectDashboardV2, d => d.pagination)
export const selectIsLoading = createSelector(selectDashboardV2, d => d.isLoading)
export const selectError = createSelector(selectDashboardV2, d => d.error)
export const selectUsersList = createSelector(selectDashboardV2, d => d.usersList)
export const selectProvidersList = createSelector(selectDashboardV2, d => d.providersList)
export const selectUrl = createSelector(selectDashboardV2, d => d.url)
export const selectPage = createSelector(selectDashboardV2, d => d.page)
export const selectCurrentContract = createSelector(selectDashboardV2, d => d.currentContract)
